// extracted by mini-css-extract-plugin
export default {"imageWrapper":"PD-z","hovered":"QD-z","hoverImage":"RD-z","mainImage":"SD-z","imageNoBackground":"TD-z","fullSizeImage":"UD-z"};